// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fyn6","controls":"styles_controls__1Q8qI","charLimit":"styles_charLimit__2DjM9","input":"styles_input__GSq9P","send":"styles_send__3p_jd"};